import { useState, useEffect } from 'react';
import { HomefieldIconAlertErrorFilled } from '@dsg-tech/homefield-react-icons';
import Swatch from './Swatch';
import { DefiningAttribute, SkuDetails } from '../FulfillmentOptions/types';

type ColorGroupProps = {
  attribute: string;
  potential: string[];
  enabled: string[];
  selected: string;
  handleClick: (value: string) => 'color';
  partNumber: string;
  getSKU: (attribute: string, value: string) => SkuDetails;
  validate: boolean;
  skuDefaultAttributes: DefiningAttribute[] | null;
};

function ColorGroup(props: Readonly<ColorGroupProps>) {
  const {
    attribute,
    potential,
    enabled,
    selected,
    handleClick,
    partNumber,
    getSKU,
    validate,
    skuDefaultAttributes,
  } = props;

  const [error, setError] = useState(false);

  useEffect(() => {
    if (skuDefaultAttributes?.length) {
      const defaultSkuColor = skuDefaultAttributes.find((attr) => attr.name === 'Color');
      handleClick(defaultSkuColor?.value ?? '');
    }
  }, [skuDefaultAttributes]);

  // Reset error state when product changes
  useEffect(() => {
    setError(false);
  }, [partNumber]);

  useEffect(() => {
    if (validate && !Array.isArray(selected) && selected.length === 0) {
      setError(true);
    } else if (selected && selected.length > 0) {
      setError(false);
    }
  }, [selected, validate]);

  return (
    <div className="attribute colors" aria-labelledby={`ColorGroup-${attribute}`}>
      {!error ? (
        <p
          id={`ColorGroup-${attribute}`}
          className={`caption hmf-body-bold-m label-base hmf-m-0 hmf-mb-xs hmf-text-transform-capitalize ${
            error && 'attribute-error'
          }`}
          data-testid={`quickViewModal_${attribute
            .replace(/[^\w]/gi, '_')
            .replace(/(_+)\1+/g, '$1')}`}>{`${attribute}: ${selected}`}</p>
      ) : (
        <p
          className="attribute-error-message hmf-subheader-bold-s"
          data-testid={`quickViewModal_error_message_${attribute
            .replace(/[^\w]/gi, '_')
            .replace(/(_+)\1+/g, '$1')}`}>
          <HomefieldIconAlertErrorFilled width="16px" height="16px" />
          {` Please Select ${attribute}`}
        </p>
      )}
      <div className="hmf-display-flex hmf-flex-row hmf-flex-wrap hmf-mb-m">
        {potential.map((value) => {
          const isSelected = selected === value;
          const isDisabled = enabled.indexOf(value) < 0;
          const sku = getSKU(attribute, value);
          return (
            <Swatch
              key={`quickview-color-swatch-${value}`}
              price={sku?.prices?.offerPrice?.toFixed(2) ?? 0}
              isClearance={sku?.clearance ?? false}
              partNumber={partNumber}
              isSelected={isSelected}
              isDisabled={isDisabled}
              color={value}
              onClick={handleClick}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ColorGroup;
